/* ----------------------------------
  lazyload Intersection Observer
---------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  let lazyImages = [].slice.call(document.querySelectorAll(".-lazyload"));
  if ("IntersectionObserver" in window) {
    let lazyImageObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          let lazyImage = entry.target;
          if (lazyImage.dataset.hasOwnProperty("src")) {
            lazyImage.src = lazyImage.dataset.src;
            lazyImage.dataset.src = "";
            delete lazyImage.dataset.src;
          }
          if (lazyImage.dataset.hasOwnProperty("srcset")) {
            lazyImage.srcset = lazyImage.dataset.srcset;
            lazyImage.dataset.srcset = "";
            delete lazyImage.dataset.srcset;
          }
          /*console.log("lazy loading!"); チェック用*/
          lazyImage.classList.remove("-lazyload");
          lazyImageObserver.unobserve(lazyImage);
        }
      });
    });
    lazyImages.forEach(function (lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
  }
});
/* ----------------------------------
  hover
---------------------------------- */
var touch =
  "ontouchstart" in document.documentElement ||
  navigator.maxTouchPoints > 0 ||
  navigator.msMaxTouchPoints > 0;

if (touch) {
  try {
    for (var si in document.styleSheets) {
      var styleSheet = document.styleSheets[si];
      if (!styleSheet.rules) continue;

      for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
        if (!styleSheet.rules[ri].selectorText) continue;

        if (styleSheet.rules[ri].selectorText.match(":hover")) {
          styleSheet.deleteRule(ri);
        }
      }
    }
  } catch (ex) {}
}

$(function () {
  burger_menu();
  btn_topscroll();
  smooth_scroll();
  menu_slidedown();
  header_fixed();
  btnmore_styling();
  btnmore_usability();
  fadein();
  /*  スマホ バーガーメニュー&メニュー
  ---------------------------------------------------*/
  function burger_menu() {
    $("#burger-bars").click(function () {
      $(this).toggleClass("-open");
      $("#header-navigation").toggleClass("-open");
      $("#global-menu").toggleClass("-open");
    });
    $("#header-navigation").click(function () {
      $("#burger-bars").removeClass("-open");
      $("#header-navigation").removeClass("-open");
      $("#global-menu").removeClass("-open");
    });
  }
  /*  トップスクロールボタン　表示切り替え
  ---------------------------------------------------*/
  function btn_topscroll() {
    var top_scroll = $("#btn-topscroll");
    top_scroll.hide();
    $(window).scroll(function () {
      if ($(this).scrollTop() > 350) {
        top_scroll.stop(true, true).fadeIn();
      } else {
        top_scroll.stop(true, true).fadeOut();
      }
    });
    $("body").on("touchmove", function () {
      if ($(this).scrollTop() > 350) {
        top_scroll.stop(true, true).fadeIn();
      } else {
        top_scroll.stop(true, true).fadeOut();
      }
    });
  }
  /*  スムーススクロール
---------------------------------------------------*/
  function smooth_scroll() {
    $(window).on("load resize", function () {
      var w = $(window).width();
      if (w >= 1024) {
        $('a[href^="#"]').click(function () {
          var speed = 500;
          var href = $(this).attr("href");
          var target = $(href == "#" || href == "" ? "html" : href);
          var position = target.offset().top - "80";
          if (href == "#") {
            position = target.offset().top;
          }
          $("html, body").stop().animate(
            {
              scrollTop: position,
            },
            speed,
            "swing"
          );
          return false;
        });
      } else {
        $('a[href^="#"]').click(function () {
          var speed = 500;
          var href = $(this).attr("href");
          var target = $(href == "#" || href == "" ? "html" : href);
          var position = target.offset().top - "80";
          if (href == "#") {
            position = target.offset().top;
          }
          $("html, body").stop().animate(
            {
              scrollTop: position,
            },
            speed,
            "swing"
          );
          return false;
        });
      }
    });
  }
  /*  グローバルメニュー　スライドダウン
  ---------------------------------------------------*/
  function menu_slidedown() {
    $(window).on("load resize", function () {
      var w = $(window).width();
      if (w >= 1024) {
        $("#global-menu > .list").hover(
          function () {
            $(this).children(".menu-child").stop().slideDown("fast");
          },
          function () {
            $(this).children(".menu-child").stop().slideUp("fast");
          }
        );
      }
    });
  }
  /*  スクロール固定ヘッダー
  ---------------------------------------------------*/
  function header_fixed() {
    $(window).on("load resize", function () {
      var w = $(window).width();
      if (w >= 1024) {
        var header_menu = $("#header-site");
        var children_menu = $(".menu-child");
        $(window).scroll(function () {
          if ($(this).scrollTop() > 400) {
            header_menu.addClass("-fixed");
            //children_menu.addClass('-fixed');
          } else {
            header_menu.removeClass("-fixed");
            //children_menu.removeClass('-fixed');
          }
        });
      }
    });
  }
  /*  フェードイン
  ---------------------------------------------------*/
  function fadein() {
    $(function () {
      $(window).scroll(function () {
        var windowHeight = $(window).height(),
          scrollY = $(window).scrollTop();

        // 通常のfadein
        $(".scroll-fadein").each(function () {
          var thisPosition = $(this).offset().top;
          if (scrollY > thisPosition - windowHeight) {
            $(this).addClass("fadein-animation-start");
          }
        });

        // scroll-fadein-thumbnailの場合
        $(".scroll-fadein-thumbnail").each(function () {
          var thisPosition = $(this).offset().top;
          if (scrollY > thisPosition - windowHeight) {
            $(this).addClass("fadein-animation-start-thumbnail");
          }
        });
      });
    });
  }
});

/*  もっと見るボタン[STYLING]
---------------------------------------------------*/
function btnmore_styling() {
  const init = 3; //初期表示数
  const more = 4; //追加表示数

  // 初期表示数以降のリスト内容を非表示に
  $(".styling-more-list li:nth-child(n+" + (init + 1) + ")").hide();

  //初期表示数以下であればMoreボタンを非表示
  $(".styling-more-list")
    .filter(function () {
      return $(this).find("li").length <= init;
    })
    .find(".btn-styling")
    .hide();

  // Moreボタンクリックで指定数表示
  $(".btn-styling").on("click", function () {
    let this_list = $(this).closest(".styling-more-list");
    this_list.find("li:hidden").slice(0, more).slideToggle();

    if (this_list.find("li:hidden").length == 0) {
      $(this).fadeOut();
    }
  });
}
/*  もっと見るボタン[USABILITY]
---------------------------------------------------*/
function btnmore_usability() {
  const init = 4; //初期表示数
  const more = 3; //追加表示数

  // 初期表示数以降のリスト内容を非表示に
  $(".usability-more-list li:nth-child(n+" + (init + 1) + ")").hide();

  //初期表示数以下であればMoreボタンを非表示
  $(".usability-more-list")
    .filter(function () {
      return $(this).find("li").length <= init;
    })
    .find(".btn-usability")
    .hide();

  // Moreボタンクリックで指定数表示
  $(".btn-usability").on("click", function () {
    let this_list = $(this).closest(".usability-more-list");
    this_list.find("li:hidden").slice(0, more).slideToggle();

    if (this_list.find("li:hidden").length == 0) {
      $(this).fadeOut();
    }
  });
}

//指定エリア内に要素を追従させる関数（追従要素,追従エリア）
const areaFixedFunk = (fixedElm, fixedArea) => {
  //エリアチェック
  const areas = document.querySelectorAll(fixedArea);
  if (areas.length === 0) {
    return;
  }

  //追従チェック関数
  const checkFixed = (target, area) => {
    //要素の位置と高さを取得
    const startPosi = area.getBoundingClientRect().top;
    const targetHeight = target.clientHeight;
    const areaHeight = area.clientHeight;
    const endPosi = startPosi + areaHeight;

    //エリア内の処理
    if (0 > startPosi && targetHeight < endPosi) {
      if (area.classList.contains("type-1")) {
        target.classList.add("fixed-styling");
        target.classList.remove("fixed-usability");
      } else if (area.classList.contains("type-2")) {
        target.classList.add("fixed-usability");
        target.classList.remove("fixed-styling");
      }
      target.style.top = "";

      //エリアより上の処理
    } else if (0 <= startPosi) {
      target.classList.remove("fixed-styling");
      target.classList.remove("fixed-usability");
      target.style.top = "";

      //エリアより下の処理
    } else {
      target.classList.remove("fixed-styling");
      target.classList.remove("fixed-usability");
      //停止位置を設定
      target.style.top = areaHeight - targetHeight + "px";
    }
  };

  //エリア毎に処理
  areas.forEach((area) => {
    //エリア内に追従要素が存在する場合のみ処理する
    const target = area.querySelector(fixedElm);
    if (target) {
      checkFixed(target, area);
      window.addEventListener("resize", () => {
        checkFixed(target, area);
      });
      window.addEventListener(
        "scroll",
        () => {
          checkFixed(target, area);
        },
        { passive: true }
      );
    }
  });
};

areaFixedFunk(".js-fixed-elm", ".js-fixed-area");
